import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useDetailsStore, useViewSettingsStore } from "../";
import DetailsType from "../interfaces/DetailsType";
import { DetailsPanelState } from "../store/ViewSettingsStore";
import styles from "./DetailsPanel.module.css";
import CloseIcon from "./icons/CloseIcon";
import { DetailsFullScreenBar, DetailsFullScreenIcon, DetailsPanelStateIcon } from "./icons/DetailsFullScreenIcon";

function DetailsPanel({ type, controls, children, onClose }: IDetailsPanelProps) {
    const navigate = useNavigate();
    const detailsStore = useDetailsStore();
    const viewSettingsStore = useViewSettingsStore();

    useEffect(() => {
        detailsStore.setType(type);
        return () => detailsStore.close();
    }, [type]);

    useEffect(() => {
        if (!detailsStore.type)
            navigate("/");
    }, [detailsStore.type]);

    return (
        <div className={[
            styles.container,
            !viewSettingsStore.isMobile && !viewSettingsStore.isDetailsFullScreen && viewSettingsStore.detailsPanelState === DetailsPanelState.Left && styles.leftContainer,
            !viewSettingsStore.isMobile && !viewSettingsStore.isDetailsFullScreen && viewSettingsStore.detailsPanelState === DetailsPanelState.Bottom && styles.bottomContainer,
        ].join(" ")}>
            <div className={styles.toolbar}>
                {!viewSettingsStore.isMobile && <DetailsFullScreenIcon />}
                {!viewSettingsStore.isMobile && <DetailsPanelStateIcon />}
                {!viewSettingsStore.isMobile && <DetailsFullScreenBar />}
                {!viewSettingsStore.isMobile && controls}
                <CloseIcon onClick={onClose} />
            </div>
            {children}
        </div>
    );
}

export default observer(DetailsPanel);

export interface IDetailsPanelProps {
    type: DetailsType;
    controls?: React.ReactNode[];
    children: React.ReactNode;
    onClose: () => void;
}